export const NS = {
  COMMON: "common",
  AUTH: "auth",
  WORKSPACE: "workspace",
  PROJECT: "project",
  DOCUMENTS: "documents",
  SALES: "sales",
} as const;

export type Namespace = (typeof NS)[keyof typeof NS];
